import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public isLoading = false;
  private requestCount = 0;

  beginRequest() {
    this.requestCount++;
    this.isLoading = true;
  }

  endRequest() {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0;
      this.isLoading = false;
    }
  }
}
